import * as React from "react";

interface IClassNameArgs {
  iconLeft?: React.ReactNode;
}

export interface TextFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  helpText?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
}
const TextField: React.FC<TextFieldProps> = ({
  iconLeft,
  iconRight,
  helpText,
  ...rest
}) => (
  <div className="flex space-x-2">
    {iconLeft ? <span>{iconLeft}</span> : null}
    {iconRight ? <span>{iconRight}</span> : null}
    <input
      {...rest}
      className="border-0 text-sm md:text-s md:tracking-wider outline-none flex-grow"
    />
  </div>
);

export default TextField;
